<template>
  <div class="container">
    <van-nav-bar :title="title" left-arrow @click-left="$router.replace({ path: '/'})">
      
    </van-nav-bar>
 
    <van-tabs v-model="activeName" sticky >
<van-tab title="全部" name="a">
    <div class="tabcontent">
      <ItemList></ItemList>
        </div>
   </van-tab>
 <van-tab title="我的预定" name="b">
        <div class="tabcontent">
              <OrderList ></OrderList>     
              </div>             
      </van-tab>

     
      
    </van-tabs>
    <secrecy></secrecy>
  </div>
</template>

<script>
import ItemList from "./components/ItemList";
import OrderList from "./components/OrderList";
import secrecy from "./components/secrecy";


//const key = "zn-history";
export default {
  name: "s7strategy",
  data() {
    return {
      scroll: 0,

     
activeName:"a",
      title: "百年糊涂-研发创意库",
    };
  },
  components: {
   OrderList,
   ItemList,
   secrecy,
 
  },
   activated() {
   
  },
  created() {
    this.initData();
  },
  updated() {
    //this.showQW();
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      if (to.path == "/hd") {
        if (to.query != from.query) {
         
          this.initData();
        
        }
      }
    },
  },

  methods: {
    async initData() {
      let type = this.$route.query.type;
      if(type!=undefined){
        this.activeName=type;
      }
      
    },
   
    
  },
};
</script>

<style lang="less" scoped>
.w100 {
  /deep/ img {
    width: 100%;
    max-height: 200px;
  }
}
.zntitle {
  height: 30px;
}
.container {
  height: 100%;
  //overflow-y: auto;
  //box-sizing: border-box;

   /deep/.van-tabs
{
   height:100%;
}
 /deep/.van-tabs__content
{
  height:100%;
}

}
.van-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
  /deep/ .van-tabs__wrap {
    height: 36px;
    padding-right: 36px;
    .van-tab {
      line-height: 36px;
    }
    .van-tabs__line {
      background-color: #3296fa;
      height: 2px;
    }
  }
  /deep/ .van-tabs__content {
    flex: 1;
    overflow: hidden;
  }
  /deep/ .van-tab__pane {
    height: 100%;
    .scroll-wrapper {
      height: 100%;
      overflow-y: auto;
    }
  }
}

.bbscontent {
  height: 100%;
}

.tabcontent {
  height: 100%;
}

.acontent {
  max-height: 300px;
  overflow: hidden;
  text-overflow: ellipsis;

  /deep/ ol {
    list-style: decimal !important;
    margin-left: 25px;
  }
  /deep/ ol li {
    list-style-position: outside;
  }
  /deep/ img {
    max-width: 33% !important;
    display: block;
    border: 0;
  }
  /deep/ video {
    max-width: 100% !important;
  }
}
.detail {
  padding: 46px 10px 44px;
  .title {
    font-size: 18px;
    line-height: 2;
  }
  .zan {
    text-align: center;
    padding: 10px 0;
    .active {
      border-color: red;
      color: red;
    }
  }
  .author {
    padding: 10px 0;
    display: flex;
    position: sticky;
    background-color: #fff;
    top: 46px;
    z-index: 2;
    .text {
      flex: 1;
      padding-left: 10px;
      line-height: 1.5;
      .name {
        font-size: 14px;
        margin: 0;
      }
      .time {
        margin: 0;
        font-size: 12px;
        color: #999;
      }
    }
  }
  .content {
    padding: 20px 0;
    overflow: hidden;
    white-space: pre-wrap;
    word-break: break-all;
    /deep/ img {
      max-width: 100%;
      background: #f9f9f9;
    }
    /deep/ code {
      white-space: pre-wrap;
    }
  }
}
</style>
